import React from 'react';
import styles from './JobActions.module.css';

interface JobActionsProps {
  jobStatus: string;
  onEdit: (e: React.MouseEvent) => void;
  onDelete: (e: React.MouseEvent) => void;
}

const JobActions: React.FC<JobActionsProps> = ({ jobStatus, onEdit, onDelete }) => {
  const isClosed = jobStatus === 'CLOSED' || jobStatus === 'PAUSED';

  return (
    <div className={styles.jobActions} onClick={(e) => e.stopPropagation()}>
      {!isClosed && (
        <button
          className={styles.jobActionButton}
          onClick={onEdit}
          title="Edit Job"
          aria-label="Edit Job"
          data-testid="job-action-edit"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
              fill="currentColor"
            />
          </svg>
        </button>
      )}
      <button
        className={styles.jobActionButton}
        onClick={onDelete}
        title="Delete Job"
        aria-label="Delete Job"
        data-testid="job-action-delete"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  );
};

export default JobActions;
